/**
 * Shared Job Context
 * Provides job modal management and job completion callbacks across features
 * Source: features/jobs - extracted for cross-feature use
 */
import { createContext, useContext } from "react";
import type { Job } from "@/shared/types/job.types";

export type OpenJobModalOptions = { autoNavigate?: boolean };

export type JobContextType = {
  isJobModalOpen: boolean
  currentJob: Job | null
  /** uuid of the job for which post-success auto-navigation is armed (fresh action only) */
  autoNavigateJobUuid: string | null
  openJobModal: (job: Job, options?: OpenJobModalOptions) => Promise<void>
  closeJobModal: () => void
  onJobComplete: (job: Job, callback: () => void) => void
  addNewJobToPushedJobs: (job: Job) => void
};

export const JobContext = createContext<JobContextType | undefined>(undefined);

export const useJobContext = () => {
  const context = useContext(JobContext);
  if (!context) throw new Error("useJobContext must be used within a JobProvider");

  return context;
};
